module.exports = __webpack_public_path__ + "img/chongwu1.df117677.png";